import { useDispatch, useSelector } from "react-redux";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { RootState } from "../../store/indexRedux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import Avatar from "react-avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

import LanguageIcon from "../svg/LanguageIcon";
import LogoutIcon from "../svg/LogoutIcon";
import ArrowLeftIcon from "../svg/ArrowLeftIcon";
import ThemeOptions from "../utils/ThemeOptions";
import MyYusoServicesIcon from "../svg/MyYusoServicesIcon";
import SwitchIcon from "../svg/SwitchIcon";
import SideMenu from "./SideMenu";
import { logout } from "../utils/cognito";
import { resetCompanyState } from "../../store/companySlice";
// import UserIcon from "../svg/UserIcon";

const MainNavigation: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const userInfo = useSelector((state: RootState) => state.user.user); // Access userInfo from Redux store

  const { i18n, t } = useTranslation("navigation");

  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLanguageMenu, setIsLanguageMenu] = useState(false);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

  const menuRef = useRef<HTMLDivElement | null>(null);
  const avatarRef = useRef<HTMLDivElement>(null);
  const hamburgerButtonRef = useRef<HTMLButtonElement | null>(null);

  const { selectedUserCompany } = useSelector((state: RootState) => state.selectedCompany);
  const email = selectedUserCompany?.email;
  const name = selectedUserCompany?.fullName;
  const companyName = selectedUserCompany?.companyName;
  const formtatedCompanyNumber = selectedUserCompany?.formattedNumber;
  const displayCompanyName =
    companyName?.length && companyName.length > 10 ? `${companyName.slice(0, 10)}...` : companyName;
  const displayCompanyNameMenu =
    companyName?.length && companyName.length > 10 ? `${companyName.slice(0, 26)}...` : companyName;

  const handleClickOutside = (event: MouseEvent) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node) &&
      avatarRef.current &&
      !avatarRef.current.contains(event.target as Node)
    ) {
      setIsMenuOpen(false);
    }
  };

  // const handleLogout = useCallback(() => {
  //   dispatch(logout());
  //   navigate('/login');
  //   setIsMenuOpen(false);
  //   setIsHamburgerOpen(false);
  // }, [dispatch, navigate]);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prevState) => !prevState);
  }, []);

  const toggleLanguageMenu = useCallback(() => {
    setIsLanguageMenu((prevState) => !prevState);
  }, []);

  const handleLanguageChange = useCallback(
    (selectedCode: string) => {
      i18n.changeLanguage(selectedCode);
      setIsMenuOpen(false);
    },
    [i18n]
  );

  const toggleHamburger = useCallback(() => {
    setIsHamburgerOpen((prevState) => !prevState);
  }, []);

  const clearAddServiceCache = () => {
    localStorage.removeItem("addServiceFormData");
    localStorage.removeItem("formVolumes");
    localStorage.removeItem("selectedServices");
    localStorage.removeItem("contractOverview");
    localStorage.removeItem("pslData");
    localStorage.removeItem("pslFullData");
    localStorage.removeItem("requiresSeparateContracts");
    localStorage.removeItem("installationNumbers");
    localStorage.removeItem("lastContractPayload");
    localStorage.removeItem("billingInfo");
    localStorage.removeItem("addServiceCompanyId");
    localStorage.removeItem("formVolumes");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex h-[80px] items-center justify-between bg-base-100  dark:bg-primary-900 ">
      <SideMenu isHamburgerOpen={isHamburgerOpen} setIsHamburgerOpen={setIsHamburgerOpen} />

      <div className="flex h-full">
        <div className="border-r-[1px] dark:border-primary-800 h-full w-[80px] flex items-center justify-center text-primary-300">
          <button
            ref={hamburgerButtonRef}
            className="flex flex-col h-4 w-6 justify-between items-center group text-primary-300"
            onClick={toggleHamburger}
          >
            <span
              className={`block w-full h-0.5 bg-current transform transition duration-500 ease-in-out ${
                isHamburgerOpen ? "rotate-45 translate-y-2 bg-white" : ""
              }`}
            />
            <span
              className={`block w-full h-0.5 bg-current transform transition duration-500 ease-in-out ${
                isHamburgerOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`block w-full h-0.5 bg-current transform transition duration-500 ease-in-out ${
                isHamburgerOpen ? "-rotate-45 -translate-y-2 bg-white" : ""
              }`}
            />
          </button>
        </div>
        {!isMobile && (
          <>
            <div className="flex items-center gap-2 justify-center px-[1.75rem] border-r-[1px] dark:border-primary-800 text-primary-600 font-semibold dark:text-white ">
              <MyYusoServicesIcon width={35} height={24} color="#91B1BE" />
              <h2> {t("title")}</h2>
            </div>

            {location.pathname !== "/" && location.pathname !== "/add-company" && (
              <div className="flex items-center gap-2 text-center justify-center h-full text-primary-400">
                <div className="ml-5 min-w-24 text-center h-full flex items-center justify-center">
                  <NavLink
                    className={({ isActive }) =>
                      `h-full flex items-center text-center transition-all duration-300 hover:text-primary-600 hover:font-semibold dark:text-primary-300 hover:dark:text-white ${
                        isActive
                          ? "font-semibold border-b-2 text-primary-600 border-secondary-600 dark:text-white"
                          : "font-normal border-b-2 border-transparent"
                      }`
                    }
                    to="/overview"
                  >
                    {t("overview")}
                  </NavLink>
                </div>
                <div className="min-w-32 text-center h-full flex items-center justify-center">
                  <NavLink
                    className={({ isActive }) =>
                      `h-full flex items-center text-center transition-all duration-300 hover:text-primary-600 hover:font-semibold dark:text-primary-300 hover:dark:text-white ${
                        isActive
                          ? "font-semibold border-b-2 border-secondary-600 text-primary-600 dark:text-white"
                          : "font-normal border-b-2 border-transparent"
                      }`
                    }
                    to="/services"
                  >
                    {t("activeServices")}
                  </NavLink>
                </div>
                <div className="min-w-28 text-center h-full flex items-center justify-center">
                  <NavLink
                    className={({ isActive }) =>
                      `h-full flex items-center text-center transition-all duration-300 hover:text-primary-600 hover:font-semibold dark:text-primary-300 hover:dark:text-white ${
                        isActive
                          ? "font-semibold border-b-2 border-secondary-600 text-primary-600 dark:text-white"
                          : "font-normal border-b-2 border-transparent"
                      }`
                    }
                    to="/documents"
                  >
                    {t("documents")}
                  </NavLink>
                </div>
                {/* Open to every authenticated user: the management landing
                    page now carries End Contract, which is no longer
                    admin-only. The admin-only cards behind it (Fluvius, BESS
                    re-sign) are gated on the page itself. */}
                <div className="min-w-32 text-center h-full flex items-center justify-center">
                  <NavLink
                    className={({ isActive }) =>
                      `h-full flex items-center text-center transition-all duration-300 hover:text-primary-600 hover:font-semibold dark:text-primary-300 hover:dark:text-white ${
                        isActive
                          ? "font-semibold border-b-2 border-secondary-600 text-primary-600 dark:text-white"
                          : "font-normal border-b-2 border-transparent"
                      }`
                    }
                    to="/management"
                  >
                    {t("management")}
                  </NavLink>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <div
        className={`flex items-center gap-5 flex-none md:mr-9 mr-1 ${
          !isMobile && "border-[1px] dark:border-primary-800"
        } rounded-[4px] py-2 px-[0.875rem]`}
      >
        <div className="flex gap-2 justify-between items-center cursor-pointer" onClick={toggleMenu} ref={avatarRef}>
          {!isMobile && <p>{displayCompanyName}</p>}
          <Avatar color="#006087" name={name} size="40" round={true} textSizeRatio={2} />
          <span className="ml-2">
            {isMenuOpen ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
          </span>
        </div>

        <div
          ref={menuRef}
          className={`absolute top-20 lg:right-4 right-3 mt-2 bg-base-100 rounded-lg shadow-lg p-2 z-50 w-60 overflow-hidden dark:bg-primary-900 transition-all duration-500 ease-in-out transform ${
            isMenuOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-5 invisible"
          }`}
        >
          <div
            style={{ width: "200%" }}
            className={`flex transition-transform duration-500 ease-in-out text-primary-400 dark:text-primary-300 ${
              isLanguageMenu ? "-translate-x-full" : "translate-x-0"
            }`}
          >
            <div className="w-full flex-shrink-0 inline-flex  text-sm">
              <div className=" w-[14rem]">
                <div className="ml-3 mb-4 ">
                  <div className="border-b-[2px] mt-2 mb-3 dark:border-primary-800">
                    <p className="dark:text-primary-300 font-semibold">{displayCompanyNameMenu}</p>
                    <p className="dark:text-primary-300 mb-3">{formtatedCompanyNumber}</p>
                  </div>
                  <p className="dark:text-primary-300">{email || userInfo?.email}</p>{" "}
                </div>
                <div className="ml-3">
                  <ThemeOptions />
                </div>
                {location.pathname !== "/" && (
                  <button
                    onClick={() => {
                      dispatch(resetCompanyState());
                      localStorage.removeItem("selectedCompanyId");
                      navigate("/");
                      clearAddServiceCache();
                      setIsMenuOpen(false);
                    }}
                    className="cursor-pointer w-full hover:bg-gray-100 hover:text-primary-400 p-3 rounded-[4px] items-center flex gap-2 group mt-3 dark:hover:bg-primary-950 dark:text-primary-300 dark:hover:text-primary-300 active:bg-primary-600 active:text-white active:font-semibold"
                  >
                    <span className="text-primary-300 dark:text-primary-500 group-hover:text-primary-300 dark:group-hover:text-primary-500">
                      <SwitchIcon />
                    </span>
                    {t("switchCompanies")}
                  </button>
                )}
                <button
                  className="cursor-pointer w-full hover:bg-gray-100 hover:text-primary-400 p-3  rounded-[4px] items-center flex gap-2 group  dark:hover:bg-primary-950 dark:text-primary-300 dark:hover:text-primary-300  active:bg-primary-600 active:text-white active:font-semibold"
                  onClick={toggleLanguageMenu}
                >
                  <span className="text-primary-300 dark:text-primary-500  group-hover:text-primary-300 dark:group-hover:text-primary-500">
                    <LanguageIcon />
                  </span>
                  {t("changeLanguage")}
                </button>
                {/* <button className="cursor-pointer w-full hover:bg-gray-100 hover:text-primary-400 dark:hover:bg-primary-950 dark:text-primary-300 dark:hover:text-primary-300  p-3   rounded-[4px] flex items-center gap-2 group  active:bg-primary-600 active:text-white active:font-semibold">
                  <span className="text-primary-300 dark:text-primary-500 group-hover:text-primary-300 dark:group-hover:text-primary-500 ">
                    <UserIcon />
                  </span>
                  {t("My account")}
                </button> */}
                <button
                  className="cursor-pointer w-full hover:bg-gray-100 hover:text-primary-400 dark:hover:bg-primary-950 dark:text-primary-300 dark:hover:text-primary-300  p-3   rounded-[4px] flex items-center gap-2 group  active:bg-primary-600 active:text-white active:font-semibold"
                  onClick={logout}
                >
                  <span className="text-primary-300 dark:text-primary-500 group-hover:text-primary-300 dark:group-hover:text-primary-500 ">
                    <LogoutIcon />
                  </span>
                  {t("logout")}
                </button>
              </div>
            </div>
            <div className=" flex-shrink-0 inline-flex  text-sm  ">
              <div className="mt-1 w-[14rem]">
                <div
                  className="cursor-pointer  py-1 flex items-center gap-2 font-semibold text-primary-600 rounded-md hover:text-primary-800 mb-3 group dark:text-primary-100 dark:hover:text-white  "
                  onClick={toggleLanguageMenu}
                >
                  <span className="text-primary-300 dark:text-primary-50 group-hover:text-primary-800 dark:group-hover:text-white">
                    <ArrowLeftIcon />
                  </span>
                  {t("language")}
                </div>
                <div className=" child:p-3 child:rounded-[4px] child:cursor-pointer ">
                  <div
                    onClick={() => handleLanguageChange("en")}
                    className={`active:bg-primary-600 dark:text-primary-300 active:text-white active:font-semibold ${
                      i18n.language === "en"
                        ? "bg-primary-600 text-white dark:text-white font-semibold"
                        : "hover:bg-gray-100 dark:hover:bg-primary-950 dark:hover:text-primary-300  hover:text-primay-400"
                    }`}
                  >
                    <p>English</p>
                  </div>
                  <div
                    onClick={() => handleLanguageChange("nl")}
                    className={` active:bg-primary-600 dark:text-primary-300 active:text-white active:font-semibold ${
                      i18n.language === "nl"
                        ? "bg-primary-600 text-white dark:text-white font-semibold"
                        : "hover:bg-gray-100 dark:hover:bg-primary-950 dark:hover:text-primary-300  hover:text-primay-400"
                    }`}
                  >
                    <p>Nederlands</p>
                  </div>
                  <div
                    onClick={() => handleLanguageChange("fr")}
                    className={`active:bg-primary-600 dark:text-primary-300 active:text-white active:font-semibold ${
                      i18n.language === "fr"
                        ? "bg-primary-600 text-white dark:text-white font-semibold"
                        : "hover:bg-gray-100 dark:hover:bg-primary-950  hover:text-primay-400 dark:hover:text-primary-300"
                    }`}
                  >
                    <p>Français</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNavigation;
